import React, { useEffect, useRef } from 'react';
import {  FaCalendarAlt, FaUser, FaArrowRight } from "react-icons/fa";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "bootstrap/dist/css/bootstrap.min.css";
import "animate.css";

const BlogPage = () => {
  // Mock data to simulate PHP backend
  const mockPosts = [
    {
      slug: "services-offered-in-customer-support",
      title: "Services Offered in Customer Support",
      excerpt:
        "Customer Support - Services is the term given to helpful services that are designed for customers during any stage of their relationship with a company.",
      author: "Admin",
      date: "2025-10-01",
      image: "/assets/images/blog/custom-support.jpg",
      categories: ["Productivity"],
      tags: ["Efficiency", "Work", "Tips"],
    },
    {
      slug: "a-look-at-a-virtual-assistants-work-desk-setup",
      title: "A Look at a Virtual Assistant’s Work-Desk Setup",
      excerpt:
        "Companies look for new ways to work faster, spend less and outperform the competition. A smart desk setup is step one.",
      author: "WorkDesk VA Team",
      date: "2025-09-20",
      image: "/assets/images/blog/virtual-assistants-work-desk-setup.jpg",
      categories: ["Remote Work"],
      tags: ["Teamwork", "Remote", "Communication"],
    },
    {
      slug: "a-review-of-trustworthy-admin-support-service",
      title: "A Review of Trustworthy Admin Support Service",
      excerpt:
        " Because businesses are choosing more flexible, digital, and economical ways to run, WorkDesk VA experts are key for managing daily operations.",
      author: "John Doe",
      date: "2025-08-15",
      image: "/assets/images/blog/admin-support-service.jpg",
      categories: ["Inspiration"],
      tags: ["Creativity", "Ideas", "Innovation"],
    },
    // {
    //   slug: "virtual-assistant-best-practices",
    //   title: "Virtual Assistant Best Practices",
    //   excerpt:
    //     "Learn the essential practices and strategies to excel as a virtual assistant in today's digital workplace.",
    //   author: "Work Desk VA",
    //   date: "2025-09-15",
    //   image: "/assets/images/blog/virtual-assistants-work-desk-setup.jpg",
    //   categories: ["Virtual Assistant"],
    //   tags: ["VA", "Best Practices", "Skills"],
    // },
    // {
    //   slug: "time-management-tips",
    //   title: "Time Management Tips for Virtual Assistants",
    //   excerpt:
    //     "Master the art of time management with these proven strategies for virtual assistants.",
    //   author: "Sarah Johnson",
    //   date: "2025-09-10",
    //   image: "/assets/images/blog/admin-support-service.jpg",
    //   categories: ["Productivity"],
    //   tags: ["Time Management", "Productivity", "VA"],
    // },
    // {
    //   slug: "client-communication",
    //   title: "Effective Client Communication Strategies",
    //   excerpt:
    //     "Develop strong client relationships through effective communication techniques and best practices.",
    //   author: "Work Desk Team",
    //   date: "2025-09-05",
    //   image: "/assets/images/blog/custom-support.jpg",
    //   categories: ["Communication"],
    //   tags: ["Client Relations", "Communication", "Business"],
    // },
    // {
    //   slug: "digital-tools-vas",
    //   title: "Essential Digital Tools for Virtual Assistants",
    //   excerpt:
    //     "A comprehensive guide to the must-have digital tools and software for modern virtual assistants.",
    //   author: "Tech Expert",
    //   date: "2025-08-30",
    //   image: "/assets/images/blog/virtual-assistants-work-desk-setup.jpg",
    //   categories: ["Technology"],
    //   tags: ["Tools", "Software", "Productivity"],
    // }
  ];

  // Display all posts without pagination
  const allPosts = mockPosts;

 const canvasRef = useRef(null);
    const mousePosRef = useRef(null);
    const pointsRef = useRef([]);
    const animationRef = useRef(null);
  
    const maxDist = 200;
    const colour = "#FFFFFF";
  
    useEffect(() => {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
  
      // Point constructor
      class Point {
        constructor() {
          this.x = (Math.random() * (canvas.width + maxDist)) - (maxDist / 2);
          this.y = (Math.random() * (canvas.height + maxDist)) - (maxDist / 2);
          this.vx = (Math.random() * 2) - 1;
          this.vy = (Math.random() * 2) - 1;
          this.dia = Math.random() * 3 + 1;
        }
      }
  
      // Generate points
      const generatePoints = (amount) => {
        pointsRef.current = [];
        for (let i = 0; i < amount; i++) {
          pointsRef.current.push(new Point());
        }
      };
  
      // Draw function
      const draw = (obj) => {
        ctx.beginPath();
        ctx.fillStyle = colour;
        if (obj.dia) {
          ctx.arc(obj.x, obj.y, obj.dia, 0, 2 * Math.PI);
        } else {
          ctx.arc(obj.x, obj.y, 2, 0, 2 * Math.PI);
        }
        ctx.closePath();
        ctx.fill();
      };
  
      // Update function
      const update = (obj) => {
        obj.x += obj.vx;
        obj.y += obj.vy;
        if (obj.x > canvas.width + (maxDist / 2)) {
          obj.x = -(maxDist / 2);
        } else if (obj.x < -(maxDist / 2)) {
          obj.x = canvas.width + (maxDist / 2);
        }
        if (obj.y > canvas.height + (maxDist / 2)) {
          obj.y = -(maxDist / 2);
        } else if (obj.y < -(maxDist / 2)) {
          obj.y = canvas.height + (maxDist / 2);
        }
      };
  
      // Collision detection and line drawing
      const collision = (obj, dist) => {
        let temp;
        for (let i = 0; i < pointsRef.current.length; i++) {
          if (obj !== pointsRef.current[i]) {
            temp = Math.sqrt(
              Math.pow((obj.x - pointsRef.current[i].x), 2) + 
              Math.pow((obj.y - pointsRef.current[i].y), 2)
            );
            if (temp < dist) {
              ctx.beginPath();
              ctx.moveTo(obj.x, obj.y);
              ctx.strokeStyle = `rgba(255,255,255,${0.8 * Math.pow((dist - temp) / dist, 5)})`;
              ctx.moveTo(obj.x, obj.y);
              ctx.lineTo(pointsRef.current[i].x, pointsRef.current[i].y);
              ctx.closePath();
              ctx.stroke();
            }
          }
        }
      };
  
      // Main animation loop
      const pointFun = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        if (mousePosRef.current) {
          collision(mousePosRef.current, maxDist * 2);
          draw(mousePosRef.current);
        }
        for (let i = 0; i < pointsRef.current.length; i++) {
          collision(pointsRef.current[i], maxDist);
          draw(pointsRef.current[i]);
          update(pointsRef.current[i]);
        }
      };
  
      // Resize canvas
      const resizeCanvas = () => {
        canvas.width = document.documentElement.clientWidth;
        canvas.height = window.innerHeight;
        generatePoints(170);
        pointFun();
      };
  
      // Mouse move handler
      const handleMouseMove = (evt) => {
        const rect = canvas.getBoundingClientRect();
        mousePosRef.current = {
          x: evt.clientX - rect.left,
          y: evt.clientY - rect.top
        };
      };
  
      // Initialize
      resizeCanvas();
      pointFun();
  
      // Start animation
      const interval = setInterval(pointFun, 16);
      animationRef.current = interval;
  
      // Event listeners
      window.addEventListener('resize', resizeCanvas);
      canvas.addEventListener('mousemove', handleMouseMove);
  
      // Cleanup
      return () => {
        clearInterval(interval);
        window.removeEventListener('resize', resizeCanvas);
        canvas.removeEventListener('mousemove', handleMouseMove);
      };
    }, []);
  
    return (
      <div style={{ 
        overflow: 'hidden',
        width: '100%',
        maxWidth: '100vw',
          paddingTop: '130px'
      }}>
        <div style={{ 
          margin: 0, 
          padding: 0, 
          overflow: 'hidden',
          width: '100%',
          height: '60vh',
          position: 'relative'
        }}>
          <canvas
            ref={canvasRef}
            id="canvas"
            style={{
              overflow: 'hidden',
              cursor: 'none',
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: 'linear-gradient(to bottom, #306873, #52A7B0)'
            }}
          />
          <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
            zIndex: 1
          }}>
                <h2 style={{
                  color: '#ffffff',
                  fontSize: '3rem',
                  fontWeight: 'bold',
                  textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                  maxWidth: '900px',
                  margin: '0 auto',
                  letterSpacing: '1px',
                  lineHeight: '1.1',
                  textAlign: 'center'
                }}>
                  About <span className="workdeskva-brand"><span className="workdeskva-bold">Work</span><span className="workdeskva-light">Desk</span> <span className="workdeskva-va">VA</span></span>
                </h2>
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: '1rem'
                }}>
                  <p style={{
                    color: '#ffffff',
                    fontSize: '1.25rem',
                    textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
                    maxWidth: '700px',
                    textAlign: 'center',
                    margin: 0,
                    lineHeight: '1.6'
                  }}>
                    <span className="workdeskva-brand"><span className="workdeskva-bold">Work</span><span className="workdeskva-light">Desk</span> <span className="workdeskva-va">VA</span></span> connects businesses with top remote talent worldwide, providing flexible and reliable staffing solutions.
                  </p>
                  <p style={{
                    color: '#ffffff',
                    fontSize: '1.25rem',
                    textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
                    maxWidth: '700px',
                    textAlign: 'center',
                    margin: '1rem 0 0 0',
                    lineHeight: '1.6'
                  }}>
                    Our mission is to empower organizations to grow and innovate with professionalism and expertise.
                  </p>
                </div>
          </div>
        </div>

      {/* Hero Carousel */}
      <section className="py-5">
        <div className="container">
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={30}
            slidesPerView={1}
            navigation={{
              nextEl: ".b1cc-swiper-button-next",
              prevEl: ".b1cc-swiper-button-prev",
            }}
            pagination={{ clickable: true }}
            autoplay={{ delay: 4000 }}
            loop
          >
            {mockPosts.map((post, index) => (
              <SwiperSlide key={index}>
                <div className="card border-0 shadow overflow-hidden">
                  <img src={post.image} alt={post.title} className="w-100" />
                  <div className="card-body">
                    <h3>{post.title}</h3>
                    <p>{post.excerpt}</p>
                    <ul className="list-inline text-muted small">
                      <li className="list-inline-item me-3">
                        <FaCalendarAlt /> {post.date}
                      </li>
                      <li className="list-inline-item">
                        <FaUser /> {post.author}
                      </li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* <div className="d-flex justify-content-between align-items-center mt-3">
            <button className="b1cc-swiper-button-prev btn btn-outline-dark">
              <FaAngleLeft />
            </button>
            <button className="b1cc-swiper-button-next btn btn-outline-dark">
              <FaAngleRight />
            </button>
          </div> */}
        </div>
      </section>

      {/* Blog Listing and Sidebar */}
      <section className="section_space">
        <div className="container">
          <div className="row">
            {/* Blog Posts */}
            <div className="col-lg-8">
              {allPosts.length === 0 ? (
                <p>No posts found.</p>
              ) : (
                allPosts.map((post, index) => (
                  <div
                    className="d-flex flex-column flex-md-row mb-4 p-3 bg-white shadow-sm rounded"
                    key={index}
                  >
                    <div className="flex-shrink-0 me-md-4 mb-3 mb-md-0">
                      <a href={`/${post.slug}`}>
                        <img
                          src={post.image}
                          alt={post.title}
                          className="rounded"
                          style={{ width: 250, height: "auto" }}
                        />
                      </a>
                    </div>
                    <div className="flex-grow-1">
                      <h4>
                        <a href={`/${post.slug}`} className="text-dark">
                          {post.title}
                        </a>
                      </h4>
                      <p>{post.excerpt}</p>
                      <ul className="list-inline small text-muted">
                        <li className="list-inline-item me-3">
                          <FaCalendarAlt /> {post.date}
                        </li>
                        <li className="list-inline-item">
                          <FaUser /> {post.author}
                        </li>
                      </ul>
                      <a
                        className="btn btn-dark mt-3 px-4 py-2 d-inline-flex align-items-center gap-2 rounded-2"
                        href={`/${post.slug}`}
                        style={{
                          transition: "all 0.3s ease"
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-2px)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                        }}
                      >
                        <span>Read More</span>
                        <FaArrowRight className="fs-6" />
                      </a>
                    </div>
                  </div>
                ))
              )}


            </div>

            {/* Sidebar */}
            <div className="col-lg-4 mt-5 mt-lg-0">
              {/* Featured Posts */}
              <div className="p-4 bg-white shadow-sm rounded mb-4">
                <h5 className="fw-bold mb-4">Featured Posts</h5>
                {mockPosts.slice(0, 3).map((post, index) => (
                  <div key={index} className={`card border-0 ${index !== 2 ? 'mb-4' : ''}`}>
                    <div className="row g-0">
                      <div className="col-4">
                        <img 
                          src={post.image} 
                          alt={post.title}
                          className="img-fluid rounded"
                          style={{ objectFit: 'cover', height: '100%' }}
                        />
                      </div>
                      <div className="col-8">
                        <div className="card-body py-0 ps-3 pe-0">
                          <h6 className="card-title mb-1">
                            <a 
                              href={`/${post.slug}`} 
                              className="text-dark text-decoration-none"
                              style={{ transition: "color 0.3s ease" }}
                              onMouseEnter={(e) => e.currentTarget.style.color = "#0d6efd"}
                              onMouseLeave={(e) => e.currentTarget.style.color = "#212529"}
                            >
                              {post.title}
                            </a>
                          </h6>
                          <p className="card-text">
                            <small className="text-muted">
                              <FaCalendarAlt className="me-1" size={12} />
                              {post.date}
                            </small>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>


  
    </div>
  );
};

export default BlogPage;
